export default "__VITE_ASSET__fiJZ$HIx__"